export default __webpack_public_path__ + "static/media/ru.814be9ce.svg";